import React, { useState } from "react";
import GradientButton from "../../components/button/Button";
import { Cam } from "../../images/Images";
import "./InviteModal.css";
import axiosInstance from "../../axiosInstance";
import { toast } from "react-toastify";

interface InviteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onFilter: (filters: {
    medium: string;
    contacts: string[];
    message: string;
  }) => void;
}

const InviteModal: React.FC<InviteModalProps> = ({
  isOpen,
  onClose,
  onFilter,
}) => {
  const [inviteMedium, setInviteMedium] = useState("email");
  const [contactInput, setContactInput] = useState("");
  const [contacts, setContacts] = useState<string[]>([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleMediumChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setInviteMedium(e.target.value);
    setContactInput("");
    setContacts([]);
  };

  // Accepts both form submit and button click
  const handleAddContact = (e?: React.FormEvent | React.MouseEvent) => {
    if (e) e.preventDefault();
    if (!contactInput.trim()) return;
    if (contacts.includes(contactInput.trim())) return;
    setContacts([...contacts, contactInput.trim()]);
    setContactInput("");
  };

  const handleRemoveContact = (item: string) => {
    setContacts(contacts.filter((c) => c !== item));
  };

  const handleFilter = async () => {
    setLoading(true);
    const payload = {
      customers: contacts.map((contact) =>
        inviteMedium === "email"
          ? { email: contact }
          : { phone_number: contact }
      ),
      channel: inviteMedium === "email" ? "email" : "sms",
      message,
    };

    console.log("Payload:", payload);

    try {
      const res = await axiosInstance.post("/customers/invitations", payload);
      toast.success(res.data?.message || "Invitations sent!");
      setContacts([]);
      setMessage("");
      onClose();
    } catch (error: any) {
      toast.error(
        error?.response?.data?.message || "Failed to send invitations."
      );
    }
    setLoading(false);
  };

  if (!isOpen) return null;

  return (
    <div className="orders-modal">
      <div className="orders-modal__overlay" onClick={onClose}></div>
      <div className="orders-modal__content">
        <div className="orders__modal__header">
          <h2 className="orders-modal__title">Invite</h2>
          <button className="orders-modal__close" onClick={onClose}>
            &times;
          </button>
        </div>
        <form className="orders-modal__form" onSubmit={handleAddContact}>
          <div className="orders-modal__form-group full">
            <label htmlFor="inviteMedium">Invite Medium</label>
            <select
              id="inviteMedium"
              value={inviteMedium}
              onChange={handleMediumChange}
            >
              <option value="email">Email</option>
              <option value="phone">Phone Number</option>
            </select>
          </div>

          <div className="orders-modal__form-group full">
            <label htmlFor="contact">
              {inviteMedium === "email" ? "Email Address" : "Phone Number"}
            </label>
            <div className="invite-modal__input-row">
              <input
                type={inviteMedium === "email" ? "email" : "tel"}
                id="contact"
                name="contact"
                placeholder={
                  inviteMedium === "email"
                    ? "Enter email"
                    : "Enter phone number eg +1945..."
                }
                value={contactInput}
                onChange={(e) => setContactInput(e.target.value)}
              />
              <GradientButton
                text="Add"
                onClick={() => handleAddContact()}
                disabled={!contactInput.trim()}
              />
            </div>
          </div>
        </form>

        {/* List of added contacts */}
        {contacts.length > 0 && (
          <div className="orders-modal__form-group full">
            <label>
              Added {inviteMedium === "email" ? "Emails" : "Phone Numbers"}
            </label>
            <ul className="invite-modal__contacts-list">
              {contacts.map((item, idx) => (
                <li key={idx} className="invite-modal__contact-item">
                  <span>{item}</span>
                  <button
                    type="button"
                    onClick={() => handleRemoveContact(item)}
                    style={{
                      background: "#f44336",
                      color: "#fff",
                      border: "none",
                      borderRadius: "50%",
                      width: 22,
                      height: 22,
                      cursor: "pointer",
                      fontWeight: "bold",
                      fontSize: 14,
                      lineHeight: "22px",
                      textAlign: "center",
                    }}
                  >
                    &times;
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* <div className="orders-modal__form-group" style={{ width: "100%" }}>
          <label htmlFor="message">Additional Text (optional)</label>
          <textarea
            id="message"
            name="message"
            placeholder="Your message..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            style={{
              width: "100%",
              padding: 4,
              resize: "none",
              outline: "none",
              borderRadius: 5,
              border: "1px solid #ccc",
              height: 100,
            }}
          />
        </div> */}

        <div className="orders-modal__actions">
          <div className="orders-modal__apply">
            <GradientButton
              onClick={handleFilter}
              text={loading ? "Sending..." : "Send"}
              disabled={contacts.length === 0 || loading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InviteModal;
